/**
 * naniexpert API 錯誤。
 *
 */
export class ApiError extends Error {
  httpStatus: number;
  code: number;

  constructor(httpStatus: number, code: number, message: string) {
    super(message);
    this.name = "ApiError";
    this.httpStatus = httpStatus;
    this.code = code;
  }
}

/**
 * 預期內的業務狀態碼（非系統故障）：
 * 403 = 非教師／編輯身分、429 = 使用次數達上限。
 * 這類錯誤不重試、也不上傳到 Sentry。
 */
export const EXPECTED_BUSINESS_CODES = new Set<number>([403, 429]);
